import React, { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTitle } from "@/components/provider/TitleProvider";
import { useContainerClass } from "@/components/provider/LayoutContainerClass";

const DebtFree = () => {
  const { setTitle } = useTitle();
  const { setContainerClass } = useContainerClass();

  useEffect(() => {
    setTitle("BuySooner - Debt-Free Partnership", "center");
    setContainerClass("main-page-section");
  }, [setTitle]);

  useEffect(() => {
    const body = document.querySelector("#root")!;
    body.scrollIntoView({
      behavior: "smooth",
    });
  }, []);

  return (
    <>
      <div className="container">
        <div className="flex flex-wrap justify-center">
          <div className="w-full md:w-5/6 lg:w-2/3">
            <p>
              With the Debt-free Partnership, we buy your home together with you as a silent partner, but you become the
              full legal owner of your home from day one – the title is 100% in your name only.
            </p>
            <p>
              Instead of taking on a mortgage (i.e. debt), we own a share which you buy back little by little from us.
              This is a perfect solution if you just don't want to take on debt for financial reasons, or if your
              religion prohibits debts that charge interest.
            </p>

            <h6 className="mt-4 mb-3">Here’s how it works:</h6>

            <div className="mb-3">
              <p className="font-bold mb-1">✔ We contribute 90% of the home price</p>
              <p className="mb-1">You contribute 10%. That means you only need a 10% deposit, not the usual 20%.</p>
              <p className="mb-0">You get into your home years earlier, without the burden of debt or interest.</p>
            </div>

            <div className="mb-3">
              <p className="font-bold mb-1">✔ You make monthly payments similar to an 80% mortgage</p>
              <p className="mb-1">
                Even though we provide 90% of the funds, your monthly payments are set at the same level as if you had
                borrowed only 80% from a bank.
              </p>
              <p className="mb-0">
                The extra 10% is your deposit boost, so you don't have to save for extra years before buying.
              </p>
            </div>

            <div className="mb-3">
              <p className="font-bold mb-1">✔ You start with 10% ownership and build more every month</p>
              <p className="mb-1">From day one, you own 10% of your home, but the title is all in your name.</p>
              <p className="mb-0">
                Each month, part of your payment increases your share, gradually buying back some of ours.
              </p>
            </div>

            <div className="mb-3">
              <p className="font-bold mb-1">✔ After 3 years you upgrade your plan</p>
              <p className="mb-1">
                When the Boost period ends (after year 3), you move to the standard rate (a slightly higher monthly
                amount – typically about 7% higher) for the remaining 27 years. For example, a $3,000 monthly repayment
                becomes $3,220.
              </p>
              <p className="mb-0">
                You can upgrade earlier, or a bit later if needed, and you can even upgrade more times if you want to
                buy us out quicker – but that's up to you.
              </p>
            </div>

            <div className="mb-3">
              <p className="font-bold mb-1">✔ After 30 years: two possible outcomes</p>
              <p className="mb-1">
                <strong>If the property hasn’t appreciated much</strong> (which is unlikely, as we help you choose a
                home that should jump a lot):
              </p>
              <p className="mb-1">
                Your fixed monthly payments will have bought back our entire 90%, so you’ll own 100% of your home
                outright.
              </p>
              <p className="mb-1">
                <strong>If the property has appreciated strongly:</strong>
              </p>
              <p className="mb-0">
                As we don't require you to increase your repurchase payments even though the property value has jumped,
                you will have bought back a little less (unless you chose to voluntarily increase your repayments). We
                may still own a small share at the end – capped at a maximum of 10%.
              </p>
            </div>

            <div className="mb-3">
              <p className="mb-1">You can:</p>
              <ul style={{ listStyleType: "inherit" }}>
                <li>Choose to enter a new plan to acquire that last portion sooner, or</li>
                <li>Simply leave it in place – and we only take our share when you sell one day.</li>
              </ul>
            </div>

            <p className="mt-3 mb-0">
              Either way, you’ve owned the home entirely in your name the whole time, with complete security and no
              debt.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

DebtFree.propTypes = {};

export default DebtFree;
